import { useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { clientReportCSV, getAllClients, searchClients, updateArchiveStatus } from "../../api/server";
import AttorneyDashBoardSidebar from "../../layouts/attorneyDashBoardSidebar";
import DashboardNavbar from "../../layouts/dashboardNavbar";
import PaginatedItems from "../dashBoardPages/pagination";
import * as Yup from "yup";
import { ThreeDots } from "react-loader-spinner";
import { useSelector } from "react-redux";
import CustomSearchByDate from "./CustomSearchByDate";
import SetupUserSelect from "../dashBoardPages/SetupUserSelect";
import { buildAppUrl } from "../../config/externalUrls";
import { copyText } from "../../utils/copyText";
import "./manage-clients.css";
// import NoteForm from "./NoteForm";

const validationSchema = Yup.object({
  search: Yup.string().required("Name/Email is required"),
});

const ManageClients = () => {
  const attorney = useSelector((state) => state.user.user.data.firstname);
  const code = useSelector((state) => state.user.user.data.attorneyCode);
  const associationUrl = `${buildAppUrl("registration")}?code=${encodeURIComponent(code || "")}`;
  const [response, setResponse] = useState();
  const [getloading, setGetLoading] = useState(true);
  const [activeSearch, setActiveSearch] = useState(false);
  const [filterLoading, setFilterLoading] = useState(false);
  const [dateFilterLoading, setDateFilterLoading] = useState(false);
const [selectedIds, setSelectedIds] = useState([]);
const [archiveLoading, setArchiveLoading] = useState(false);

  const [pageCache, setPageCache] = useState({});
  const [searchCache, setSearchCache] = useState({});
  const [pageNo, setPageNo] = useState(1);
  const [total, setTotal] = useState();
  // const [notes , setNotes] = useState()
  const checked = ["checked", "Checked", "complete", "Complete"];
  const [csvLoading, setCsvLoading] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [order, setOrder] = useState("ASC");
  const [copied, setCopied] = useState(false);
  const copyTimer = useRef();
  useEffect(() => () => clearTimeout(copyTimer.current), []);
const handleCheckboxChange = (userID) => {
  setSelectedIds((prev) =>
    prev.includes(userID) ? prev.filter((id) => id !== userID) : [...prev, userID]
  );
};

const handleAddToArchive = async () => {
  if (selectedIds.length === 0) {
    toast.warn("Please select at least one client to archive.");
    return;
  }
  const payload = { archive: 1, ids: selectedIds };
  setArchiveLoading(true);
  try {
    const res = await updateArchiveStatus(payload);
    console.log("archive update response", res);
    toast.success("Clients archived successfully.");
    setSelectedIds([]);
    setPageCache({});
    setSearchCache({});
  } catch (err) {
    toast.error(err?.response?.data?.error || "Failed to archive clients");
  } finally {
    setArchiveLoading(false);
  }
};
 const donwloadCSV = async () => {
  const payload = {
    attorneyname: values.attorneyname || "", // always send this
    search: values.search || "",
    order: values.order || "DESC", 
    ...(startDate && endDate
      ? { date: { start: startDate, end: endDate } }
      : { date: { start: "", end: "" } }), // send empty date object if not selected
  };

  setCsvLoading(true);

  try {
    const res = await clientReportCSV(payload);
    console.log("kasdfkjads",res)
    const linkHandler = document.getElementById("csvhandler");
    if (linkHandler && res?.data?.csvLink) {
      linkHandler.setAttribute("href", res.data.csvLink);
      linkHandler.click();
    }

    setCsvLoading(false);
  } catch (err) {
    toast.error(err?.response?.data?.error || "CSV download failed");
    setCsvLoading(false);
  }
};


  const { handleChange, touched, values, errors, handleSubmit, resetForm, setFieldValue ,setFieldTouched} =
    useFormik({
      initialValues: { search: "", attorneyname: attorney, order: "ASC" },
      validationSchema: validationSchema,
      onSubmit: (values) => {
        if (searchCache[pageNo]) {
          // Data already in cache, no need for API call
          const { cachedResponse, cachedTotal } = searchCache[pageNo];
          setResponse(cachedResponse);
          setTotal(cachedTotal);
        } else {
          const finalParams = {
            ...values,
            order: values.order || "ASC",
            date: {
              start: startDate,
              end: endDate,
            },

          };
          setFilterLoading(true);
          setGetLoading(true);
          searchClients(pageNo, finalParams)
            .then((res) => {
              setActiveSearch(true);
              // const groupedById = {};
              const ungroupData = res.data.result;
              // ungroupData.forEach((obj) => {
              //   if (!groupedById[obj.userID]) {
              //     groupedById[obj.userID] = [];
              //   }
              //   groupedById[obj.userID].push(obj);
              // });

              // const newData = Object.values(groupedById);
              const groupedById = new Map();

          ungroupData.forEach((obj) => {
            if (!groupedById.has(obj.userID)) {
              groupedById.set(obj.userID, []);
            }
            groupedById.get(obj.userID).push(obj);
          });

          // Sort within each group: Main first, Joint second
          groupedById.forEach((users) => {
            users.sort((a, b) => {
              if (a.type === "Main" && b.type !== "Main") return -1;
              if (a.type !== "Main" && b.type === "Main") return 1;
              return 0;
            });
          });

          const newData = Array.from(groupedById.values());
              const newTotal = res.data.total;
              // const newData = res.data.result;
              // const newTotal = res.data.total;
              setSearchCache((prevCache) => ({
                ...prevCache,
                [pageNo]: { cachedResponse: newData, cachedTotal: newTotal },
              }));
              setResponse(newData);
              setTotal(newTotal);
              if (pageNo === 1) toast.success("Client search successful");
              setFilterLoading(false);
              setGetLoading(false);
            })
            .catch((err) => {
              toast.error(err.response.data.error);
              setFilterLoading(false);
              setGetLoading(false);
            });
        }
      },
    });

  const handlePageChange = () => {
    if (activeSearch) handleSubmit(values.search);
  };

  // const handleClearFilters = () => {
  //   const { cachedResponse, cachedTotal } = pageCache[pageCache.pageNo];
  //   setPageNo(pageCache.pageNo);
  //   setActiveSearch(false);
  //   setTotal(cachedTotal);
  //   setSearchCache({});
  //   setResponse(cachedResponse);
  //   resetForm();
  //   toast.success("Client search cleared");
  // };
  const handleClearFilters = () => {
    setFieldValue("search", "");
     setFieldTouched("search", false); 
    setActiveSearch(false);

    // toast.success("Client search cleared");

    // Keep date and order, only reset search
    handleSearchOrDefault({ search: "" , order: values.order || "ASC" });
  };
  

  const handleCopy = async (url) => {
    try {
      await copyText(url);
      clearTimeout(copyTimer.current);
      setCopied(true);
      copyTimer.current = setTimeout(() => setCopied(false), 1800);
    } catch (error) {
      toast.error("Unable to copy link. Please try again.");
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (pageCache[pageNo]) {
        // Data already in cache, no need for API call
        const { cachedResponse, cachedTotal } = pageCache[pageNo];
        setResponse(cachedResponse);
        setTotal(cachedTotal);
      } else {
        setGetLoading(true);
        try {
          const res = await getAllClients(pageNo, { attorneyname: attorney,order: order,archive: false });
          const ungroupData = res.data.result;
          // //  setNotes(res.data?.notes)
          // const groupedById = {};

          // ungroupData.forEach((obj) => {
          //   if (!groupedById[obj.userID]) {
          //     groupedById[obj.userID] = [];
          //   }
          //   groupedById[obj.userID].push(obj);
          // });

          // const newData = Object.values(groupedById);
          const groupedById = new Map();

          ungroupData.forEach((obj) => {
            if (!groupedById.has(obj.userID)) {
              groupedById.set(obj.userID, []);
            }
            groupedById.get(obj.userID).push(obj);
          });

          // Sort within each group: Main first, Joint second
          groupedById.forEach((users) => {
            users.sort((a, b) => {
              if (a.type === "Main" && b.type !== "Main") return -1;
              if (a.type !== "Main" && b.type === "Main") return 1;
              return 0;
            });
          });

          const newData = Array.from(groupedById.values());
          const newTotal = res.data.total;

          // Update the cache with new data
          setPageCache((prevCache) => ({
            ...prevCache,
            [pageNo]: { cachedResponse: newData, cachedTotal: newTotal },
          }));

          // Set state with new data
          setResponse(newData);
          setTotal(newTotal);
        } catch (err) {
          toast.error(err.response.data.error);
        } finally {
          setGetLoading(false);
        }
      }
    };
    if (!activeSearch) {
      fetchData();
    }
  }, [pageNo, pageCache, order]);

  const handleDateFilterSubmit = (start, end) => {
    setStartDate(start);
    setEndDate(end);

    const cacheKey = `${pageNo}_${values.search || "noSearch"}_${start || "noStart"}_${end || "noEnd"}}`;

    if (searchCache[cacheKey]) {
      const { cachedResponse, cachedTotal } = searchCache[cacheKey];
      setResponse(cachedResponse);
      setTotal(cachedTotal);
    } else {
      setDateFilterLoading(true);
      setGetLoading(true);

      const params = {
        attorneyname: values.attorneyname || "",
        order: values.order || "ASC",
        date: {
          start,
          end,
        },
        search: values.search || "",
        // order: values.order || "DESC",
      };

      searchClients(pageNo, params)
        .then((res) => {
          const groupedById = {};
          res.data.result.forEach((obj) => {
            if (!groupedById[obj.userID]) {
              groupedById[obj.userID] = [];
            }
            groupedById[obj.userID].push(obj);
          });

          const newData = Object.values(groupedById);
          const newTotal = res.data.total;

          setSearchCache((prevCache) => ({
            ...prevCache,
            [cacheKey]: { cachedResponse: newData, cachedTotal: newTotal },
          }));

          setResponse(newData);
          setTotal(newTotal);
        })
        .catch((err) => {
          toast.error(err.response?.data?.error || "Date filter failed");
        })
        .finally(() => {
          setDateFilterLoading(false);
          setGetLoading(false);
        });
    }
  };

  const handleSearchOrDefault = (overrides = {}) => {
  const { start, end, ...restOverrides } = overrides;

  const payload = {
    search: values.search,
    attorneyname: values.attorneyname,
    // order,
    ...restOverrides, // any additional fields
    ...(start && end ? { date: { start, end } } : {}), // include date only if both provided
  };

  
    const effectiveStart = overrides.start ?? startDate;
    const effectiveEnd = overrides.end ?? endDate;

    if (effectiveStart && effectiveEnd) {
      payload.date = {
        start: effectiveStart,
        end: effectiveEnd,
      };
    }

    // Create cache key (optional: you can improve or hash it if needed)
    const cacheKey = `${pageNo}_${payload.search}_${payload.attorneyname}_${effectiveStart}_${effectiveEnd}`;

    if (searchCache[cacheKey]) {
      const { cachedResponse, cachedTotal } = searchCache[cacheKey];
      setResponse(cachedResponse);
      setTotal(cachedTotal);
      setActiveSearch(!!payload.search);
    } else {
      setFilterLoading(true);
      setGetLoading(true);

      searchClients(pageNo, payload)
        .then((res) => {
          setActiveSearch(!!payload.search);
          const groupedById = {};
          res.data.result.forEach((obj) => {
            if (!groupedById[obj.userID]) groupedById[obj.userID] = [];
            groupedById[obj.userID].push(obj);
          });

          const newData = Object.values(groupedById);
          const newTotal = res.data.total;

          setSearchCache((prev) => ({
            ...prev,
            [cacheKey]: { cachedResponse: newData, cachedTotal: newTotal },
          }));
          setResponse(newData);
          setTotal(newTotal);
        })
        .catch((err) => {
          toast.error(err.response?.data?.error || "Search failed");
        })
        .finally(() => {
          setFilterLoading(false);
          setGetLoading(false);
        });
    }
  };

  const handleResetDate = () => {
    setStartDate("");
    setEndDate("");

    // Keep search and order, only reset date
    handleSearchOrDefault({ start: "", end: "" });
  };
  return (
    <div>
      <a id="csvhandler" target="_blank"></a>
      <div className="wrapper">
        <AttorneyDashBoardSidebar />
        <div id="content" className="attorney-clients-page">
          <DashboardNavbar />
          {
            console.log("responseresponse", response)
          }
          {/* <!-- Page Content Holder --> */}
          <section className="manage-students">
            {/* {
            !getloading &&
            <NoteForm note={notes} />
           }  */}
            {code && (
              <p className="clients-association">
                Association Link:{" "}
                <b>{associationUrl}</b>
                <button
                  className={`clients-copy-button${copied ? " is-copied" : ""}`}
                  type="button"
                  aria-label={copied ? "Association link copied" : "Copy association link"}
                  title={copied ? "Copied" : "Copy link"}
                  disabled={copied}
                  onClick={() => {
                    handleCopy(associationUrl);
                  }}
                >
                  <i className={`fa ${copied ? "fa-check" : "fa-clone"}`} aria-hidden="true"></i>
                </button>
              </p>
            )}
            <div className="card">
              <div className="card-header">
                <div className="clients-date-filter">
                <CustomSearchByDate
                  onDateFilter={handleDateFilterSubmit}
                  onReset={handleResetDate}
                  dateFilterLoading={dateFilterLoading}
                />
                </div>
                <div className="clients-toolbar">

                  <div className="clients-title">
                    <h4 className="card-title">Manage Clients</h4>
                  </div>

                  {/* <div className="col-lg-3" style={{ textAlign: 'end' }}>
                   
                  </div> */}

                  <div className="clients-tools">
                     <button
                      className="btn_brnd"
                      type="button"
                      disabled={csvLoading}
                      onClick={() => {
                        donwloadCSV(values)
                      }}
                    >
                      {csvLoading ? (
                        <ThreeDots
                          height="14"
                          width="38"
                          radius="4"
                          color="#4fa94d"
                          ariaLabel="three-dots-loading"
                          wrapperStyle={{ display: "block" }}
                          wrapperClassName="spinner"
                          visible={true}
                        />
                      ) : (
                        "Export Data"
                      )}
                    </button>
                    <form onSubmit={handleSubmit} className="clients-search-form">
                      <div className="clients-sort">
                        <label className="visually-hidden" htmlFor="client-sort-order">Sort clients</label>
                        <SetupUserSelect
                          id="client-sort-order"
                          name="order"
                          value={order}
                          onChange={(e) => {
                            const newOrder = e.target.value;
                            setOrder(newOrder);
                            setFieldValue("order", newOrder);
                            setPageCache({});        // <-- add this
                            setSearchCache({});      // <-- add this
                            // handleSearchOrDefault({ order: newOrder });
                          }}
                        >
                          <option value="DESC">Descending</option>
                          <option value="ASC">Ascending</option>
                        </SetupUserSelect>
                      </div>
                      <div className="table-search">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search"
                          aria-label="Search clients"
                          style={{ paddingRight: "35px" }}
                          onChange={handleChange}
                          name="search"
                          value={values.search}
                        />
                        <button
                          disabled={filterLoading || getloading}
                          type="submit"
                          aria-label="Search clients"
                          onClick={() => {
                            setPageCache((prevCache) => ({
                              ...prevCache,
                              pageNo: pageNo,
                            }));
                            setPageNo(1);
                            setSearchCache({});
                          }}
                        >
                          <i className="fa fa-search"></i>
                        </button>
                         {errors.search && touched.search ? (
                        <p className="text-danger mt-1">{errors.search}</p>
                      ) : null}
                      </div>
                     

                    </form>
                    {activeSearch && (
                      <button
                        className="btn_brnd me-3 flex"
                        onClick={handleClearFilters}
                        type="button"
                      >
                        Clear Search
                      </button>
                    )}
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div className="clients-table-scroll" role="region" aria-label="Client list" tabIndex={0}>
                <table className="table clients-table">
                  <colgroup><col style={{ width: "27%" }} /><col style={{ width: "35%" }} /><col style={{ width: "14%" }} /><col style={{ width: "14%" }} /><col style={{ width: "10%" }} /></colgroup>
                  <thead>
                    <tr>
                      <th scope="col">Name</th>
                      <th scope="col">Email</th>
                      <th scope="col">Course 1</th>
                      <th scope="col">Course 2</th>
                      <th scope="col">Archive</th>
                    </tr>
                  </thead>
                  <tbody>
                    {getloading ? (
                      <tr>
                        <td colSpan={5}>
                          <ThreeDots
                          height="20"
                            width="48"
                            radius="4"
                            color="#4fa94d"
                            ariaLabel="three-dots-loading"
                            wrapperStyle={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                            wrapperClassName="spinner"
                            visible={true}
                          />
                        </td>
                      </tr>
                    ) : response && response.length > 0 ? (
                      response.map((users, index) =>
                        users.map((user, ind) => (
                          <tr key={index}>
                            <th
                              scope="row"
                              style={{
                                textTransform: "none",
                                borderBottomWidth:
                                  ind !== users.length - 1 ? "0px" : "",
                              }}
                            >
                              {user.type === "Joint"
                                ? user.jointFirstName === "" &&
                                  user.jointLastName === ""
                                  ? user.userFirstName +
                                  " " +
                                  user.userLastName +
                                  "'s Joint"
                                  : user.jointFirstName +
                                  " " +
                                  user.jointLastName +
                                  " (Joint)"
                                : user.userFirstName + " " + user.userLastName}
                            </th>
                            <td
                              style={{
                                textTransform: "none",
                                borderBottomWidth:
                                  ind !== users.length - 1 ? "0px" : "",
                              }}
                            >
                              {user.userEmail}
                            </td>
                            <td
                              style={{
                                borderBottomWidth:
                                  ind !== users.length - 1 ? "0px" : "",
                              }}
                            >
                              {" "}
                              {user.courseFirstId &&
                                user.courseFirstGenterated == "yes" ? (
                                user.courseFirstDownloaded &&
                                  user.courseFirstDownloaded !== "yes" ? (
                                  <a
                                    className="text-black"
                                    href={user.courseFirstDownloaded}
                                    target="_blank"
                                  >
                                    {user.courseFirstDate
                                      ? user.courseFirstDate.split("T")[0]
                                      : ""}
                                  </a>
                                ) : user.courseFirstDate ? (
                                  <span className="tooltips">
                                    {user.courseFirstDate.split("T")[0]}
                                  </span>
                                ) : (
                                  ""
                                )
                              ) : user.courseFirstGenterated == "" &&
                                user.perFirstCourse == 100 ? (
                                "Pending"
                              ) : checked.includes(user.activated_first) ? (
                                user.perFirstCourse.toFixed(0) + "%"
                              ) : (
                                "Not Enrolled"
                              )}
                            </td>

                            <td
                              style={{
                                borderBottomWidth:
                                  ind !== users.length - 1 ? "0px" : "",
                              }}
                            >
                              {user.courseSecondId &&
                                user.generated == "yes" ? (
                                user.downloaded && user.downloaded !== "yes" ? (
                                  <a
                                    className="text-black"
                                    href={user.downloaded}
                                    target="_blank"
                                  >
                                    {user.date ? user.date.split("T")[0] : ""}
                                  </a>
                                ) : user.date ? (
                                  <span className="tooltips">
                                    {user.date.split("T")[0]}
                                  </span>
                                ) : (
                                  ""
                                )
                              ) : user.generated == "" &&
                                user.perSecondCourse == 100 ? (
                                "Pending"
                              ) : checked.includes(user.activated_second) ? (
                                user.perSecondCourse.toFixed(0) + "%"
                              ) : (
                                "Not Enrolled"
                              )}
                            </td>
                            {/* {ind === 0 ? ( */}
                            <td
                              // rowSpan={users.length}
                              style={{ verticalAlign: "middle", textAlign: "center" }}
                            >
                              <input
                                type="checkbox"
                                aria-label={`Archive ${user.userFirstName} ${user.userLastName}${user.type === "Joint" ? " (Joint)" : ""}`}
                                className="custom_checkbox"
                                checked={selectedIds.includes(user.userID)}
                                onChange={() => handleCheckboxChange(user.userID)}
                                style={{ width: "18px", height: "18px", cursor: "pointer" }}
                              />
                            </td>
                            {/* ) : null } */}
                          </tr>
                        ))
                      )
                    ) : (
                      <tr>
                        <td colSpan={5}>No client found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
                </div>
                {!filterLoading && !getloading && total !== 0 && total > 50 && (
                  <PaginatedItems
                    responsive
                    total={total}
                    pageNo={pageNo}
                    setPageNo={setPageNo}
                    handlePageChange={handlePageChange}
                  />
                )}
              </div>
              <div className="clients-archive-actions">
                {selectedIds.length > 0 && (
                  <button
                    className="btn_brnd"
                    style={{ padding: "6px 20px", fontWeight: "500" }}
                    type="button"
                    disabled={archiveLoading}
                    onClick={handleAddToArchive}
                  >
                    {archiveLoading ? (
                      <ThreeDots
                        height="14" width="38" radius="4" color="#4fa94d"
                        ariaLabel="three-dots-loading"
                        wrapperStyle={{ display: "block" }}
                        wrapperClassName="spinner"
                        visible={true}
                      />
                    ) : (
                      `Add to Archive`
                    )}
                  </button>
                )}
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default ManageClients;
